import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '@sharedcommon/services/user.service';
import { Constants } from '@sharedcommon/util/constants.util';

@Component({
  selector: 'home-redirection-page',
  templateUrl: './home-redirection.page.html'
})
export class HomeRedirectionPage {

  isIE = Constants.IS_INTERNET_EXPLORER;

  constructor(
    private readonly router: Router,
    private readonly userService: UserService
  ) {
    if (this.userService.isSampleOperatingMode()) {
      this.router.navigate(["/app/samples"]);
    } else {
      this.router.navigate(["/app/rawmaterials"]);
    }
  }
}
